import { useTranslation } from 'react-i18next'
import { StyledSecondaryButton } from './styled'

interface ButtonProps {
  text?: string
  style?: React.CSSProperties
  disabled?: boolean
  handleClick: () => void
}

const SecondaryButton: React.FC<ButtonProps> = ({
  text,
  style,
  disabled,
  handleClick,
}) => {
  const { t } = useTranslation()
  const textLabel = text ?? t('ok')

  return (
    <StyledSecondaryButton
      style={style}
      disabled={disabled}
      onClick={handleClick}
    >
      {textLabel}
    </StyledSecondaryButton>
  )
}

export default SecondaryButton
